import { lazy } from 'react'

const AppRoutes = [
  {
    path: '/apps/ecommerce/custom-swag-packs',
    className: 'ecommerce-application',
    component: lazy(() => import('../../views/apps/ecommerce/swag-packs')),
    meta: {
      publicRoute: true,
      action: 'list',
      resource: 'orders_ecommerce'
    }
  },
  {
    path: '/apps/ecommerce/pack/:id',
    exact: true,
    className: 'ecommerce-application',
    component: lazy(() =>
      import('../../views/apps/ecommerce/swag-pack-detail')
    ),
    meta: {
      publicRoute: true,

      action: 'list',
      resource: 'orders_ecommerce',
      navLink: '/apps/ecommerce/pack/'
    }
  },
  {
    path: '/apps/ecommerce/shop',
    className: 'ecommerce-application',
    component: lazy(() => import('../../views/apps/ecommerce/shop')),
    meta: {
      publicRoute: true,

      action: 'true',
      resource: 'brands_v2'
    }
  },
  {
    path: '/apps/ecommerce/wishlist',
    className: 'ecommerce-application',
    component: lazy(() => import('../../views/apps/ecommerce/wishlist')),
    meta: {
      publicRoute: true,
      action: 'list',
      resource: 'orders_ecommerce'
    }
  },
  {
    path: '/apps/ecommerce/product-detail',
    exact: true,
    className: 'ecommerce-application',
    // component: () => (
    //   <Redirect to="/apps/ecommerce/product-detail/apple-i-phone-11-64-gb-black-26" />
    // ),
    meta: {
      publicRoute: true,
      action: 'list',
      resource: 'orders_ecommerce'
    }
  },
  {
    path: '/apps/ecommerce/product-detail/:product',
    exact: true,
    className: 'ecommerce-application',
    component: lazy(() => import('../../views/apps/ecommerce/detail')),
    meta: {
      publicRoute: true,

      action: 'list',
      resource: 'orders_ecommerce',
      navLink: '/apps/ecommerce/product'
    }
  },
  {
    path: '/apps/ecommerce/product/:product',
    exact: false,
    className: 'ecommerce-application',
    component: lazy(() => import('../../views/apps/ecommerce/detail')),
    meta: {
      publicRoute: true,

      action: 'list',
      resource: 'orders_ecommerce',
      navLink: '/apps/ecommerce/product'
    }
  },
  {
    path: '/apps/ecommerce/product/:product/:variation',
    exact: false,
    className: 'ecommerce-application',
    component: lazy(() => import('../../views/apps/ecommerce/detail')),
    meta: {
      publicRoute: true,

      action: 'list',
      resource: 'orders_ecommerce',
      navLink: '/apps/ecommerce/product'
    }
  },
  {
    path: '/apps/ecommerce/checkout',
    className: 'ecommerce-application',
    component: lazy(() => import('../../views/apps/ecommerce/checkout')),
    meta: {
      publicRoute: true,
      action: 'list',
      resource: 'orders_ecommerce',
      contentWidth: 'boxed'
    }
  }

  // {
  //   path: '/apps/user/list',
  //   component: lazy(() => import('../../views/apps/user/list'))
  // },
  // {
  //   path: '/apps/user/edit',
  //   exact: true,
  //   component: () => <Redirect to='/apps/user/edit/1' />
  // },
  // {
  //   path: '/apps/user/edit/:id',
  //   component: lazy(() => import('../../views/apps/user/edit')),
  //   meta: {
  //     navLink: '/apps/user/edit'
  //   }
  // },
  // {
  //   path: '/apps/user/view',
  //   exact: true,
  //   component: () => <Redirect to='/apps/user/view/1' />
  // },
  // {

  //   path: '/apps/user/view/:id',
  //   component: lazy(() => import('../../views/apps/user/view')),
  //   meta: {
  //     navLink: '/apps/user/view'
  //   }
  // }
]

export default AppRoutes
